
import Headroom from "../headroom.js";
import Splide from "../splide.min.js";


// Header
const myElement = document.querySelector("#header");
const headroom = new Headroom(myElement);

if (window.innerWidth > 1023) {
      headroom.init();
}

// -------------------------------------------
// -------------------------------------------
// Carrousel : Splide.JS
// -------------------------------------------
// -------------------------------------------

const speedSlider = 800;
const heightSlider = "100%"

// Splide 1
var splideMain = new Splide('.splide.LP-sport__vestiaire-main', {

      type: 'splide',
      perPage: 1,
      direction: 'ttb',
      height: heightSlider,

      pagination: true,

      speed: speedSlider,

      paginationDirection: 'ttb',

      arrows: false,
      cover: true,
      drag: false,
      autoplay: false,

      classes: {
            pagination: 'splide__pagination splide__pagination--vestiaire',
            page: 'splide__pagination__page heading-01 color-white x-upper',
      },

      breakpoints: {
            1023: {
                  direction: 'ltr',
            },
      }

})

// Splide 2
var splideSecond = new Splide('.splide.LP-sport__vestiaire-second', {

      type: 'splide',
      perPage: 1,
      direction: 'ttb',
      height: heightSlider,

      pagination: false,

      speed: speedSlider,

      arrows: false,
      cover: false,
      drag: false,
      autoplay: false,

      breakpoints: {
            1023: {
                  direction: 'ltr',
            },
      }

})

// Splide 3
var splideText = new Splide('.splide.LP-sport__vestiaire-text', {

      type: 'splide',
      perPage: 1,
      direction: 'ttb',
      height: heightSlider,

      pagination: false,

      speed: speedSlider,

      arrows: false,
      cover: false,
      drag: false,
      autoplay: false,

      breakpoints: {
            1023: {
                  direction: 'rtl',
            },
      }

})


// Fonction pour synchroniser les carrousels
function synchronizeCarousels(splide1, splide2, splide3) {
      // Déplace les deux autres carrousels en fonction du premier
      splide1.on('move', () => {
            let currentIndex = splide1.index;

            // setTimeout(function () {
                  splide2.go(currentIndex);
            // }, speedSlider / 6);

            // setTimeout(function () {
                  splide3.go(currentIndex);
            // }, speedSlider / 6);

      });
}

document.addEventListener('DOMContentLoaded', function () {

      new Splide('.splide.LP-sport__mosaic-bloc', {
            type: 'splide',
            pagination: false,
            arrows: true,

            cover: true,
            drag: true,

            classes: {
                  arrow: 'splide__arrow custom-arrow',
                  prev: 'splide__arrow--prev custom-prev',
                  next: 'splide__arrow--next custom-next',
            },
      }).mount();

      // --------------------------------------------------------------
      // Launch slider 1
      // --------------------------------------------------------------
      const jobs = ["Tennis", "Kitesurf", "Boxe", "Para triathlon", "Judo", "Handball"];

      splideMain.on('pagination:mounted', function (data) {

            // `items` contains all dot items
            data.items.forEach(function (item, index) {
                  item.button.innerHTML = jobs[index];
                  item.button.setAttribute("data-text", jobs[index]);
            });

            let pagination = document.querySelector('.LP-sport__vestiaire-main .splide__pagination');

            if (pagination) {
                  document.querySelector(".LP-sport__vestiaire-main-menu").appendChild(pagination);
            }

      });

      splideMain.mount();

      // --------------------------------------------------------------
      // Launch slider 2
      // --------------------------------------------------------------

      splideSecond.mount();

      // --------------------------------------------------------------
      // Launch slider 3
      // --------------------------------------------------------------

      splideText.mount();

      // --------------------------------------------------------------
      // Synchronise les carrousels avec une animation au démarrage
      synchronizeCarousels(splideMain, splideSecond, splideText)

});

// Fonction qui permet de créer des ancrages
function ancrage(click, destination) {
      if (document.querySelector(destination)) {
          let itemClick = document.querySelector(click);
  
          itemClick.addEventListener("click", function() {
              window.scrollTo({
                  top: ((document.querySelector(destination).offsetTop - 50)),
                  behavior: 'smooth',
              });
          });
      }
  }
  
  ancrage('.arrow-sportwomen', '.LP-sport__vestiaire');

  function isElementVisible(el) {
      const elementTop = el.offsetTop;
      const viewportTop = window.pageYOffset;
      const viewportBottom = viewportTop + window.innerHeight;

      return elementTop < viewportBottom;
  }

  function checkVisibilityAndToggle(hideClass, watchClass) {
      const elementsToHide = document.querySelectorAll(`.${hideClass}`);
      const elementsToWatch = document.querySelectorAll(`.${watchClass}`);

      elementsToWatch.forEach(watchElement => {
          const isVisible = isElementVisible(watchElement);

          elementsToHide.forEach(hideElement => {
              hideElement.style.display = isVisible ? 'none' : 'flex';
          });
      });
  }

  // Check visibility on scroll, resize, and initial load
  function initVisibilityCheck(hideClass, watchClass) {
      function check() {
          checkVisibilityAndToggle(hideClass, watchClass);
      }
      window.addEventListener('scroll', check);
      window.addEventListener('resize', check);
      document.addEventListener('DOMContentLoaded', check);
  }

  // Initialize the visibility check with the specific classes
  initVisibilityCheck('arrow-sportwomen', 'LP-sport__vestiaire');